// extracted by mini-css-extract-plugin
export default {"box":"content-module--box--1739d","scrollable":"content-module--scrollable--e00e8","mobile":"content-module--mobile--d2a21"};